/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface UpdateDocumentRequestDocument
 */
export interface UpdateDocumentRequestDocument {
  /**
   *
   * @type {string}
   * @memberof UpdateDocumentRequestDocument
   */
  title?: string
  /**
   *
   * @type {string}
   * @memberof UpdateDocumentRequestDocument
   */
  description?: string
  /**
   *
   * @type {string}
   * @memberof UpdateDocumentRequestDocument
   */
  memo?: string
  /**
   *
   * @type {string}
   * @memberof UpdateDocumentRequestDocument
   */
  label?: string
  /**
   *
   * @type {Array<string>}
   * @memberof UpdateDocumentRequestDocument
   */
  labelIds?: Array<string>
}

export function UpdateDocumentRequestDocumentFromJSON(json: any): UpdateDocumentRequestDocument {
  return UpdateDocumentRequestDocumentFromJSONTyped(json, false)
}

export function UpdateDocumentRequestDocumentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateDocumentRequestDocument {
  if (json === undefined || json === null) {
    return json
  }
  return {
    title: !exists(json, 'title') ? undefined : json['title'],
    description: !exists(json, 'description') ? undefined : json['description'],
    memo: !exists(json, 'memo') ? undefined : json['memo'],
    label: !exists(json, 'label') ? undefined : json['label'],
    labelIds: !exists(json, 'label_ids') ? undefined : json['label_ids']
  }
}

export function UpdateDocumentRequestDocumentToJSON(value?: UpdateDocumentRequestDocument | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    title: value.title,
    description: value.description,
    memo: value.memo,
    label: value.label,
    label_ids: value.labelIds
  }
}
